import Modal from './Modal';

export default Modal;



// WEBPACK FOOTER //
// ./src/modal/index.js